import React, { createContext, useContext } from 'react';

const ClientHeaderContext = createContext();
export const useClientHeader = () => useContext(ClientHeaderContext);

export function ClientHeaderProvider({ value, children }) {
    return (
        <ClientHeaderContext.Provider value={value}>
            {children}
        </ClientHeaderContext.Provider>
    );
}
